import { requester } from '../utils';

export const getRegionsList = (id, query) => {
  return new Promise((resolve, reject) => {
    requester
      .fetchAPI({
        route: `v1/region/byCityId/${id}?${query}`,
        method: 'GET',
        withAuth: true
      })
      .then(result => {
        resolve(result.payload);
      })
      .catch(err => {
        console.log('fetch region list error', err);
        reject(err);
      });
  });
};

export const getAllRegionsNames = data => {
  return new Promise((resolve, reject) => {
    requester
      .fetchAPI({
        route: `v1/region/byCityCode`,
        method: 'POST',
        withAuth: true,
        data
      })
      .then(result => {
        resolve(result.payload);
      })
      .catch(err => {
        console.log('fetch region list error', err);
        reject(err);
      });
  });
};

export const getRegionById = id => {
  return new Promise((resolve, reject) => {
    requester
      .fetchAPI({
        route: `v1/region/${id}`,
        method: 'GET',
        withAuth: true
      })
      .then(result => {
        resolve(result.payload);
      })
      .catch(err => {
        console.log('fetch region error', err);
        reject(err);
      });
  });
};

export const updateRegion = (reqObject, id) => {
  return new Promise((resolve, reject) => {
    requester
      .fetchAPI({
        route: `v1/region/${id}`,
        method: 'PUT',
        data: reqObject,
        withAuth: true
      })
      .then(result => {
        resolve(result.payload);
      })
      .catch(err => {
        console.log('update region error', err);
        reject(err);
      });
  });
};

export const addNewRegion = reqObject => {
  return new Promise((resolve, reject) => {
    requester
      .fetchAPI({
        route: `v1/region`,
        method: 'POST',
        data: reqObject,
        withAuth: true
      })
      .then(result => {
        resolve(result.payload);
      })
      .catch(err => {
        console.log('add new region error', err);
        reject(err);
      });
  });
};